import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';

// Muestra un texto recortado a N líneas; si el contenido DESBORDA (se mide de
// verdad, así funciona también con muchas líneas cortas), un enlace "Ver más"
// abre un modal con el texto completo. Estilos inline para poder usarlo tanto en
// la app (Bootstrap) como en el área cliente (clases cp-*) sin acoplarse a ninguno.
const ExpandableText = ({ text, title = 'Detalle', lines = 3, className = '', linkLabel = 'Ver más' }) => {
  const [open, setOpen] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setOverflow(el.scrollHeight - el.clientHeight > 1);
  }, [text, lines]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  if (!text) return null;

  return (
    <>
      <p
        ref={ref}
        className={className}
        style={{
          whiteSpace: 'pre-wrap',
          margin: 0,
          display: '-webkit-box',
          WebkitLineClamp: lines,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {text}
      </p>
      {overflow && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          style={{ background: 'none', border: 'none', padding: 0, marginTop: 4, color: '#2E9BE0', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer' }}
        >
          {linkLabel}
        </button>
      )}
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(5,51,102,0.45)', zIndex: 1080, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 640, maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: '14px 18px', borderBottom: '1px solid #e2e8f0' }}>
              <strong style={{ color: '#0f2540', fontSize: '1rem' }}>{title}</strong>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Cerrar"
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', lineHeight: 1, color: '#64748b', cursor: 'pointer' }}
              >
                ×
              </button>
            </div>
            <div style={{ padding: 18, overflowY: 'auto', whiteSpace: 'pre-wrap', color: '#0f2540', lineHeight: 1.55 }}>
              {text}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpandableText;
